export const UNSUPPORTED_CONTENT = 'UNSUPPORTED_CONTENT'
export const COPYRIGHT_INFRINGEMENT = 'COPYRIGHT_INFRINGEMENT'
export const PERSONAL_CONTENT = 'PERSONAL_CONTENT'
export const OTHER = 'OTHER'
